import {
  icon_default
} from "./chunk-4PTUQGAR.js";

// src/blocks/icon/index.ts
var icon_default2 = icon_default;

export {
  icon_default2 as icon_default
};
